module.exports = __webpack_public_path__ + "img/bg_g@3x.3f70863b.png";